import { Handle, Position } from '@xyflow/react';

function SensorHandle({
  posTop,
  id,
  disabled,
}: {
  posTop?: string;
  id?: string;
  disabled?: boolean;
}) {
  return (
    <Handle
      type="source"
      position={Position.Right}
      style={{
        width: '16px',
        height: '16px',
        backgroundColor: 'transparent',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(posTop !== undefined && {
          position: 'absolute',
          top: posTop,
        }),
      }}
      {...(id !== undefined ? { id } : {})} // conditionally add id prop
    >
      <div
        style={{
          width: '8px',
          height: '8px',
          backgroundColor: 'white',
          border: disabled ? '1px solid #8D8D8D' : '1px solid #239AE7',
          borderRadius: '50%',
          pointerEvents: 'none',
        }}
      />
    </Handle>
  );
}

export default SensorHandle;
